import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const DeleteNope = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      clipRule="evenodd"
      d="M7.095 18.32c3.131 2.43 7.69 2.209 10.562-.663 2.872-2.872 3.093-7.43.663-10.562L7.095 18.32ZM5.68 16.905 16.905 5.68c-3.131-2.43-7.69-2.209-10.562.663-2.872 2.872-3.093 7.431-.663 10.563ZM4.93 4.93c3.889-3.89 10.253-3.89 14.142 0 3.89 3.89 3.89 10.253 0 14.142-3.89 3.89-10.253 3.89-14.142 0-3.89-3.889-3.89-10.253 0-14.142Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default DeleteNope;
